export const CLIP = 'CLI';
export const CLIPESODE = 'CLI';
export const EPISODE = 'EPI';
export const MARATHON = 'STR';
export const STREAM = 'STR';



// WEBPACK FOOTER //
// ./src/common/constants/analytics-video-type.js